// extracted by mini-css-extract-plugin
export default {"root":"navigation-menu_root__j9AZa","footnote":"navigation-menu_footnote__YpqhC","footnoteHeading":"navigation-menu_footnoteHeading__glomk"};